import React from 'react'
import workdata from './Works_data'

function About() {
    const reactProj = workdata.filter(data => data.type === "react");
    const mernProj = workdata.filter(data => data.type === "mern");
    return (
        <>
            <div className="row mt-5">
                <div className="col text-center">
                    <p className="h2">About Me</p>
                    <p className="text-primary">My introduction</p>
                </div>
            </div>
            <div className="row mt-3 r2">
                <div className="col-sm-6">
                    <div className="aboutdesc p-3">
                        <div className="row">
                            <div className="col">
                                <p style={{textAlign:"left"}}>
                                I am a fresher but I have some prior self-experience of full-stack
                                    web development that I have achieved by creating my projects. I included some of my projects in my work section.
                                    I like to learn new things and always try to do my work on time and in a better way.
                                    I also have done certification in web development and have React.js test completion certification which is included in my resume provided below.
                                </p>
                                <div className="proj">
                                    <div className="c1">
                                        <p className="h3">{mernProj.length}</p><small className="text-muted">Major projects</small>
                                    </div>
                                    <div className="c2">
                                        <p className="h3">{reactProj.length}</p><small className="text-muted">Mini projects</small>
                                    </div>
                                </div>
                                <a href="https://drive.google.com/uc?id=1jdIsITPyCJ4eyM8rDMcdI0JZWbuSvYms&export=download" className="btn" id="btnn" title="Download my Resume">Download cv <i className="fa fa-download" style={{ fontSize: "100%", margin: "0px 3px" }}></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 aimg">
                    <div className="aboutimg">
                        <img src="https://thumbs.dreamstime.com/z/person-using-laptop-computer-person-using-laptop-computer-above-166137900.jpg" alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default About
